import * as React from "react";

const QuickSummary = (props) => {

    const title = props.title;
    const description = props.description;

    return (
        <>
            <div className="quick-summary">
                <p><strong dangerouslySetInnerHTML={{ __html: title }} /></p>
                <div dangerouslySetInnerHTML={{ __html: description }} />
            </div>
        </>
    )
}

QuickSummary.defaultProps = {
    title: "Quick Summary",
    description: "Quick summary description",
    sectionClass: 'bg-white'
}

export default QuickSummary;